import { render, staticRenderFns } from "./SearchCategoriesDesktop.vue?vue&type=template&id=22e85641&"
import script from "./SearchCategoriesDesktop.vue?vue&type=script&lang=ts&"
export * from "./SearchCategoriesDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./SearchCategoriesDesktop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports